/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export enum IUCNStatus {
  EXTINCT = '#061d33',
  EXTINCT_IN_WILD = '#061d33',
  CRITICALLY_ENDANGERED = '#cc3333',
  ENDANGERED = '#cc6633',
  VULNERABLE = '#cc9900',
  NEAR_THREATENED = '#006666',
  LEAST_CONCERN = '#006666',
  NOT_EVALUATED = '#a0aec0',
  DATA_DEFICIENT = '#a0aec0',
}

const stringToIUCNStatus = (status: string): IUCNStatus => {
  switch (status) {
    case 'EX':
      return IUCNStatus.EXTINCT;
    case 'EW':
      return IUCNStatus.EXTINCT_IN_WILD;
    case 'CR':
      return IUCNStatus.CRITICALLY_ENDANGERED;
    case 'EN':
      return IUCNStatus.ENDANGERED;
    case 'VU':
      return IUCNStatus.VULNERABLE;
    case 'NT':
      return IUCNStatus.NEAR_THREATENED;
    case 'LC':
      return IUCNStatus.LEAST_CONCERN;
    case 'NE':
      return IUCNStatus.NOT_EVALUATED;
    case 'DD':
      return IUCNStatus.DATA_DEFICIENT;
    default:
      throw new Error(`Unhandled IUCN status: ${status}`);
  }
};

export const IUCNStatusIcon = ({
  ariaLabel = 'IUCN Status',
  status,
  ...props
}: IIconProps & { status: IUCNStatus | string }) => {
  const color = status.includes('#') ? status : stringToIUCNStatus(status);
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...{ width: 32, height: 32 },
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <circle cx="16" cy="16" r="16" fill={color} />
    </svg>
  );
};
